import { paginationResponseTransformer } from '@/utils/pagination/pagination';
import { getRequest } from '../request/request.service';
import { Surveys, SurveysFilters } from './surveys-service.types';

const SURVEYS_URL = 'surveys';
export function getSurveys(params: SurveysFilters) {
  return getRequest<Surveys>(`/${SURVEYS_URL}`, { params }, paginationResponseTransformer);
}

export function exportSurveys(params: SurveysFilters) {
  return getRequest<string>(`/${SURVEYS_URL}/export_surveys`, {
    params,
    responseType: 'text',
  });
}
